import { useState } from 'react';
import { styleLooks, styleCategories } from '@/mocks/styleGuide';

export default function LookbookGrid() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [expanded, setExpanded] = useState<string | null>(null);

  const filtered = activeCategory === 'all'
    ? styleLooks
    : styleLooks.filter((l) => l.category === activeCategory);

  return (
    <section className="bg-[#FDFAF5] py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10">
          <p className="font-sans text-[1rem] text-[#C49A3E] tracking-widest mb-3 font-medium">
            LOOKBOOK
          </p>
          <h2 className="font-serif text-[1.5rem] md:text-[2.125rem] text-[#2C2118] font-semibold leading-[1.4] mb-4">
            本季精選 Look
          </h2>
          <p className="font-sans text-[1.1875rem] text-[#2C2118]/60 leading-[1.75] max-w-lg mx-auto">
            每個 Look 都是可直接複製的完整造型，單品皆可在門市或線上找到
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap items-center justify-center gap-2 mb-12">
          {styleCategories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.id)}
              className={`whitespace-nowrap font-sans text-[1rem] font-medium px-5 py-2 rounded-full border transition-all duration-200 cursor-pointer ${
                activeCategory === cat.id
                  ? 'bg-[#2C2118] border-[#2C2118] text-white'
                  : 'border-[#E8D7AE] text-[#2C2118]/70 hover:border-[#C49A3E] hover:text-[#C49A3E]'
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* Looks Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {filtered.map((look) => (
            <article
              key={look.id}
              className="group bg-white rounded-2xl overflow-hidden border border-[#F5EDD8] hover:border-[#E8D09A] transition-all duration-300"
            >
              <div className="flex flex-col sm:flex-row">
                {/* Image */}
                <div className="relative w-full sm:w-[220px] h-[320px] sm:h-auto flex-shrink-0 overflow-hidden bg-[#FAF5EB]">
                  <img
                    src={look.image}
                    alt={look.title}
                    title={`${look.title} - ${look.category}`}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <span
                    className="absolute top-3 left-3 text-white text-xs font-sans font-semibold tracking-widest px-3 py-1 rounded-full"
                    style={{ backgroundColor: look.color }}
                  >
                    {look.tag}
                  </span>
                </div>

                {/* Info */}
                <div className="flex-1 p-6 flex flex-col justify-between">
                  <div>
                    <p className="font-sans text-[1rem] text-[#C49A3E] tracking-wide mb-1 font-medium">
                      {look.category}
                    </p>
                    <h3 className="font-serif text-[1.25rem] md:text-[1.375rem] text-[#2C2118] font-semibold leading-[1.5] mb-3">
                      {look.title}
                    </h3>
                    <p className="font-sans text-[1rem] text-[#2C2118]/65 leading-[1.75] mb-5">
                      {look.desc}
                    </p>

                    {/* Item List */}
                    <div>
                      <button
                        onClick={() => setExpanded(expanded === look.id ? null : look.id)}
                        className="flex items-center gap-2 font-sans text-[1rem] text-[#2C2118] font-medium mb-3 cursor-pointer hover:text-[#C49A3E] transition-colors"
                      >
                        <i className={`${expanded === look.id ? 'ri-subtract-line' : 'ri-add-line'} text-lg`}></i>
                        造型單品清單
                      </button>
                      {expanded === look.id && (
                        <ul className="space-y-2">
                          {look.items.map((item, idx) => (
                            <li key={idx} className="flex items-center gap-2 font-sans text-[1rem] text-[#2C2118]/70">
                              <span className="w-5 h-5 flex items-center justify-center">
                                <i className="ri-checkbox-circle-line text-[#C49A3E]"></i>
                              </span>
                              {item}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>

                  <button className="whitespace-nowrap mt-6 self-start font-sans text-[1rem] font-medium border border-[#2C2118] text-[#2C2118] px-6 py-2.5 rounded-full hover:bg-[#2C2118] hover:text-white transition-all duration-300 cursor-pointer">
                    探索此系列單品
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
